export default {"src":"/_next/static/media/ic-smiley-rating.05334ab2.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};